export default function backoffice(podeAcessar, authUserInfo) {
  const ehEmpresa = (...codigos) => codigos.includes(authUserInfo?.codemp);

  return [
    {
      name: 'Inicio',
      icon: 'fa fa-th-large fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: true,
      link: '/app/backof/inicio',
    },
    {
      name: 'Control Desk',
      icon: 'fa fa-table fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('back_controldesk'),
      link: '/app/backof/controldesk',
    },
    {
      name: 'Operacional',
      icon: 'fa fa-cogs fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      ativo:
        podeAcessar('back_fila_acionamento') ||
        podeAcessar('back_liberacao_acordo') ||
        podeAcessar('back_titulos_a_liberar') ||
        podeAcessar('back_negativacao') ||
        podeAcessar('back_documentos_digitais'),
      children: [
        {
          name: 'Fila de Acionamento',
          type: 'item',
          ativo: podeAcessar('back_fila_acionamento'),
          link: '/app/backof/operacional/fila-acionamento',
        },
        {
          name: 'Liberação de Acordos',
          type: 'item',
          ativo: podeAcessar('back_liberacao_acordo'),
          link: '/app/backof/operacional/acordos-liberados',
        },
        {
          name: 'Títulos a serem Liberados',
          type: 'item',
          ativo: podeAcessar('back_titulos_a_liberar'),
          link: '/app/backof/operacional/titulos-serem-liberados',
        },
        {
          name: 'Negativação',
          type: 'item',
          ativo: podeAcessar('back_negativacao'),
          link: '/app/backof/operacional/negativacao',
        },
        {
          name: 'Documentos Digitais',
          type: 'item',
          ativo: podeAcessar('back_documentos_digitais'),
          link: '/app/backof/operacional/documentos-digitais',
        },
      ],
    },
    {
      name: 'Importações',
      icon: 'fa fa-user-plus fa-fw',
      iconSize: '1.2em',
      ativo:
        podeAcessar('back_importacoes_tit') ||
        podeAcessar('back_manutencao_tit') ||
        podeAcessar('back_importacao_oco'),
      type: 'collapse',
      children: [
        {
          name: 'Importação de Títulos',
          type: 'item',
          ativo: podeAcessar('back_importacoes_tit'),
          link: '/app/backof/importacoes/titulos',
        },
        {
          name: 'Importação de Títulos x Baixa de Carteira',
          type: 'item',
          ativo: podeAcessar('back_importacoes_tit'),
          link: '/app/backof/importacoes/titulos-baixa',
        },
        {
          name: 'Manutenção de Importações',
          type: 'item',
          ativo: podeAcessar('back_manutencao_tit'),
          link: '/app/backof/importacoes/titulos-manutencao',
        },
        {
          name: 'Lotes de Títulos Enviados pelo Credor',
          type: 'item',
          ativo: podeAcessar('back_importacoes_tit'),
          link: '/app/backof/importacoes/lotes-credor',
        },
        {
          name: 'Importação de Ocorrências',
          type: 'item',
          ativo: podeAcessar('back_importacao_oco'),
          link: '/app/backof/importacoes/ocorrencias',
        },
      ],
    },
    {
      name: 'Higienizações',
      icon: 'fa fa-retweet fa-fw',
      iconSize: '1.2em',
      ativo:
        podeAcessar('back_higienizacao_dev') ||
        podeAcessar('back.higienizacao.tit'),
      type: 'collapse',
      children: [
        {
          name: 'Higienizar Devedores',
          type: 'item',
          ativo: podeAcessar('back_higienizacao_dev'),
          link: '/app/backof/higienizacao-devedores',
        },
        {
          name: 'Atualizar Títulos',
          type: 'item',
          ativo: podeAcessar('back.higienizacao.tit'),
          link: '/app/backof/higienizacao-titulos',
        },
      ],
    },
    {
      name: 'Devoluções / Retiradas',
      icon: 'fa fa-user-times fa-fw',
      iconSize: '1.2em',
      ativo: podeAcessar('back_devolucao'),
      type: 'collapse',
      children: [
        {
          name: 'Devolução de Processo',
          type: 'item',
          ativo: podeAcessar('back_devolucao'),
          link: '/app/backof/devolucao/devolucao-titulos',
        },
        {
          name: 'Devolução por Prazo',
          type: 'item',
          ativo: podeAcessar('back_devolucao'),
          link: '/app/backof/devolucao/devolucao-por-prazo',
        },
      ],
    },
    {
      name: 'Ações Eletrônicas',
      icon: 'fa fa-envelope fa-fw',
      iconSize: '1.2em',
      ativo: !(
        podeAcessar('back_acoes_email') == false &&
        podeAcessar('back_acoes_sms') == false &&
        podeAcessar('back_acoes_boletos') == false
      ),
      type: 'collapse',
      children: [
        {
          name: 'Campanha de E-mail',
          type: 'item',
          ativo: podeAcessar('back_acoes_email'),
          link: '/app/backof/acoeseletronicas/campanha-email',
        },
        {
          name: 'Campanha de SMS',
          type: 'item',
          ativo: podeAcessar('back_acoes_sms'),
          link: '/app/backof/acoeseletronicas/campanha-sms',
        },
        {
          name: 'Emissão de Faturas / Boletos em Lote',
          type: 'item',
          ativo: podeAcessar('back_acoes_boletos'),
          link: '/app/backof/acoeseletronicas/campanha-boleto',
        },
        {
          name: 'Modelos de E-mail',
          type: 'item',
          ativo: podeAcessar('back_acoes_email'),
          link: '/app/backof/acoeseletronicas/modelo-email',
        },
        {
          name: 'Modelos de SMS',
          type: 'item',
          ativo: podeAcessar('back_acoes_sms'),
          link: '/app/backof/acoeseletronicas/modelo-sms',
        },
      ],
    },
    {
      name: 'Discador',
      icon: 'zmdi zmdi-hc-fw zmdi-phone',
      ativo: podeAcessar('back_discador'),
      type: 'collapse',
      children: [
        {
          name: 'Mailling',
          type: 'item',
          ativo: true,
          link: '/app/backof/discador/mailling',
        },
        {
          name: 'Automação de URA',
          type: 'item',
          ativo: true,
          link: '/app/backof/discador/mailling-auto',
        },
        {
          name: 'Importar / Retorno',
          type: 'item',
          ativo: false,
          link: '/app/xxx',
          bloq: true,
        },
      ],
    },
    {
      name: 'FTP',
      icon: 'fa fa-folder fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      ativo: podeAcessar('back.ftp'),
      children: [
        {
          name: 'Meus Arquivos',
          type: 'item',
          ativo: podeAcessar('back.ftp'),
          link: '/app/backof/ftp/meus-arquivos',
        },
        {
          name: 'Logs Automações',
          type: 'item',
          ativo: podeAcessar('back.ftp'),
          link: '/app/backof/ftp/automacoes',
        },
        {
          name: 'Usuários',
          type: 'item',
          ativo: podeAcessar('back.ftp'),
          link: '/app/backof/ftp/usuarios',
        },
      ],
    },
    {
      name: 'Históricos',
      icon: 'fa fa-check-square-o fa-fw',
      type: 'collapse',
      ativo: true,
      children: [
        {
          name: 'Acessos',
          type: 'item',
          ativo: podeAcessar('back_hist_acessos'),
          link: '/app/backof/historico-de-acesso',
        },
        {
          name: 'Ações',
          type: 'item',
          ativo: podeAcessar('back_hist_acessos'),
          link: '/app/backof/historico-de-acoes',
        },
        {
          name: 'Higienizações',
          type: 'item',
          ativo: true,
          link: '/app/backof/historico-higienizacao',
        },
        {
          name: 'SMSs Enviados',
          type: 'item',
          ativo: true,
          link: '/app/backof/sms-enviados',
        },
        {
          name: 'E-mails Enviados',
          type: 'item',
          ativo: true,
          link: '/app/backof/emails-enviados',
        },
      ],
    },
    {
      name: 'Automações',
      icon: 'fa fa-cogs fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      ativo: podeAcessar('back_automacoes'),
      children: [
        {
          name: 'Emissão de Relatórios',
          type: 'item',
          ativo: true,
          link: '/app/backof/automacoes/relatorios',
        },
        {
          name: 'Automações Diversas',
          type: 'item',
          ativo: true,
          link: '/app/backof/automacoes/diversos',
        },
        {
          name: 'Eventos',
          type: 'item',
          ativo: true,
          link: '/app/backof/automacoes/eventos',
        },
      ],
    },
    {
      name: 'Ferramentas',
      icon: 'fa fa-wrench fa-fw',
      type: 'collapse',
      ativo:
        podeAcessar('back_baixas_titulos_planilha') ||
        podeAcessar('back_baixas_titulos_lote') ||
        podeAcessar('back_migrar_processos') ||
        podeAcessar('back_encerrar_processo_sem_saldo') ||
        podeAcessar('back_distribuicao_processo_planilha') ||
        podeAcessar('back_alterar_neg_acordo_planilha') ||
        podeAcessar('back_atualizar_status_planilha') ||
        podeAcessar('back_devedor_titulo_excluido') ||
        podeAcessar('back_atualiza_fones') ||
        podeAcessar('tab_tags_marcacoes') ||
        ehEmpresa(
          'fc65cb',
          'bo49ka',
          'md22cb',
          'it23sd',
          'so61cb',
          'hg39xv',
          'slc1584' //** Usado este hash só para testar na base teste
        ),
      children: [
        {
          name: 'Baixas de Títulos por Planilha',
          type: 'item',
          ativo: podeAcessar('back_baixas_titulos_planilha'),
          link: '/app/backof/tools/baixas-por-planilha',
        },
        {
          name: 'Baixas de Títulos em Lote',
          type: 'item',
          ativo: podeAcessar('back_baixas_titulos_lote'),
          link: '/app/backof/tools/baixa-titulos-lote',
        },
        {
          name: 'Migração de Processos por Planilha',
          type: 'item',
          ativo: podeAcessar('back_migrar_processos'),
          link: '/app/backof/tools/migrar-processos',
        },
        {
          name: 'Encerrar Processos sem Saldo',
          type: 'item',
          ativo: podeAcessar('back_encerrar_processo_sem_saldo'),
          link: '/app/backof/tools/encerrar-processos',
        },
        {
          name: 'Distribuição de Processos por Planilha',
          type: 'item',
          ativo: podeAcessar('back_distribuicao_processo_planilha'),
          link: '/app/backof/tools/distribuicao-processos-planilha',
        },
        {
          name: 'Atualização de Tags nos Processos por Planilha',
          type: 'item',
          ativo: podeAcessar('tab_tags_marcacoes'),
          link: '/app/backof/tools/atualizacao-tags-processos-planilha',
        },
        {
          name: 'Alterar o Negociador do Acordo por Planilha',
          type: 'item',
          ativo: podeAcessar('back_alterar_neg_acordo_planilha'),
          link: '/app/backof/tools/troca-negociador-acordo',
        },
        {
          name: 'Atualização de Status/Fase do Processo por Planilha',
          type: 'item',
          ativo: podeAcessar('back_atualizar_status_planilha'),
          link: '/app/backof/tools/atualiza-status-processo-em-lote',
        },
        {
          name: 'Devedores/Títulos Excluídos',
          type: 'item',
          ativo: podeAcessar('back_devedor_titulo_excluido'),
          link: '/app/backof/tools/devedores-titulos-excluidos',
        },
        {
          name: 'Arquivo - Sercomtel',
          type: 'item',
          ativo: ehEmpresa('fc65cb'), // FACTO
          link: '/app/backof/tools/0501',
        },
        {
          name: 'Arquivo - Digimais',
          type: 'item',
          ativo: ehEmpresa('fc65cb'), // FACTO
          link: '/app/backof/tools/0502',
        },
        {
          name: 'Importar Recebimentos (Gera)',
          type: 'item',
          ativo: ehEmpresa('bo49ka'), // OBOTICARIOCARIRI
          link: '/app/backof/tools/importar-recebimentos-gera',
        },
        {
          name: 'Importação CRMs Diversos',
          type: 'item',
          ativo: ehEmpresa(
            'bo38cg', // BOMEN
            'md22cb',
            'it23sd',
            'so61cb', // SOLIDUZ
            'hg39xv', // HIUGOU
            'slc1584' //** Usado este hash só para testar na base teste
          ),
          link: '/app/backof/tools/importacao-crms-diversos',
        },
        {
          name: 'Atualização de Telefones por Planilha',
          type: 'item',
          ativo: podeAcessar('back_atualiza_fones') == true,
          link: '/app/backof/tools/atualizacao-telefones-planilha',
        },
      ],
    },
  ];
}
